/**
 * Service layer — the feeder setting on milestone types (docs/OPERATING_MODEL.md, build step 2).
 * Every milestone type is OUR milestone (crewed work) or a FEEDER (owed to us by someone else).
 * Talks to /api/milestone-types only.
 */

async function authToken() {
  if (typeof window === 'undefined') return null
  for (let i = 0; i < 20; i++) {
    if (typeof window.__clerkGetToken === 'function') {
      try { const t = await window.__clerkGetToken(); if (t) return t } catch { /* not ready */ }
    }
    await new Promise(r => setTimeout(r, 150))
  }
  return null
}
async function post(body) {
  const token = await authToken()
  const res = await fetch('/api/milestone-types', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: 'Bearer ' + token } : {}) },
    body: JSON.stringify(body),
  })
  const json = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(json.error || ('Request failed: ' + res.status))
  return json
}

/** Who owes a feeder, in the words every screen uses. */
export const OWED_BY_LABELS = { agency: 'The City', consultant: 'A consultant', client: 'The client', gc: 'The GC' }
export const OWED_BY_KINDS = ['agency', 'consultant', 'client', 'gc']

/** { settings: { [typeId]: { kind, owedBy, note } }, coordinators: { [owedBy]: { roleLabel, memberId, memberName } } } */
export function listMilestoneTypeSettings() { return post({ action: 'list' }) }

/** kind: 'milestone' | 'feeder'. A feeder needs owedBy. Returns the refreshed list. */
export function setMilestoneTypeKind(typeId, kind, owedBy, note) {
  return post({ action: 'set', typeId, kind, owedBy: owedBy || null, note: note ?? null })
}

export function setFeederCoordinator(owedBy, memberAirtableId, memberName) {
  return post({ action: 'setCoordinator', owedBy, memberAirtableId, memberName })
}
